module.exports = __webpack_public_path__ + "img/gsap.311d59a6.svg";